// extracted by mini-css-extract-plugin
module.exports = {"textPrimary":"_12DjYnA7NOg9RrQUGkacxg","textSecondary":"_1rTFkImPVB_xEBOLm5YOFs","mainPrimary":"_2xJoLgT1Ps0zQRPnpmxNz9"};